export * from './TextBlock';

import { TextBlock } from './TextBlock';

export default TextBlock;
